import React from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useIntl } from "react-intl";
import { messages } from "./Introduction.messages";
import { useBlocks } from "@jelly/lesson";

import styles from "./Introduction.module.scss";

interface VirtualAcoustics {
  title: string;
}

export const Introduction: React.FC<VirtualAcoustics> = () => {
  const block = useBlocks();
  const { formatMessage } = useIntl();

  const leftComponent = (
    <div className={styles.leftComponent}>
      <p>{formatMessage(messages.C4_P1_S1_Description)}</p>
    </div>
  );

  return (
    <div className={styles.root}>
      <StandardCase title={formatMessage(messages.C4_P1_S1_Title)} leftComponent={leftComponent}>
        <div className={styles.rightComponent}>
          <block.video src={"videoUrl"} provider="youtube" />
        </div>
      </StandardCase>
    </div>
  );
};
